<template lang="html">
    <d-list-group flush>
      <d-list-group-item class="p-0">
        <d-form @submit.prevent="submit()">
          <d-form-row>

            <!-- Tempo de Garantia Default -->
            <d-col md="3" class="form-group">
              <label for="feWarrantyDefault">Tempo de Garantia Padrão</label>
              <d-form-input id="feWarrantyDefault" v-model="model.warranty" placeholder="Ano, mês, dias"/>
            </d-col>

            <!-- Tempo Alerta -->
            <d-col md="3" class="form-group">
              <label for="feTempoAlerta">Tempo Alerta ao cliente</label>
              <d-form-input type="number" id="feTempoAlerta" placeholder="Tempo de espera em dias" v-model="model.timeAlert"/>
            </d-col>

          </d-form-row>

          <d-form-row>
            <d-col md="3" class="form-group">
              <label for="feLogo">Logo</label>
              <div class="custom-file mb-3">
                <input type="file" class="custom-file-input" id="feLogo" ref="file" @change="choseFile()"/>
                <label class="custom-file-label" for="feLogo">{{ file.name }}</label>
              </div>
            </d-col>
          </d-form-row>

          <d-form-row>
            <d-col md="3" class="form-group">
              <label for="feResellerNational">Representante Nacional padrão</label>
              <autocomplete
                ref="resellerNational"
                placeholder="Representante nacional"
                parameter="national"
                :items="resellers"
                item-show="name"
                :on-input="onInput"
                :on-select="saveReseller"
              ></autocomplete>
            </d-col>
            <d-col md="3" class="form-group">
              <label for="feResellerInternational">Representante Internacional padrão</label>
              <autocomplete
                ref="resellerInternational"
                placeholder="Representante internacional"
                parameter="international"
                :items="resellers"
                item-show="name"
                :on-input="onInput"
                :on-select="saveReseller"
              ></autocomplete>
            </d-col>
            <d-col md="3" class="form-group">
              <label for="feResellerEngineering">Representante Engenharia padrão</label>
              <autocomplete
                ref="resellerEngineering"
                placeholder="Representante engenharia"
                parameter="engineering"
                :items="resellers"
                item-show="name"
                :on-input="onInput"
                :on-select="saveReseller"
              ></autocomplete>
            </d-col>
          </d-form-row>

          <d-form-row>
            <d-button type="submit" class="btn-primary">Salvar</d-button>
          </d-form-row>
        </d-form>

      </d-list-group-item>
    </d-list-group>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Autocomplete from '_shared/Autocomplete.vue';
import ResellerService from '_services/rest/modules/reseller';
import SettingsService from '_services/rest/modules/settings';
import { _LOAD_MODEL_SETTING_, SETTINGS } from './SettingsModel';

export default {
  name: 'settings-form',
  components: {
    Autocomplete,
  },
  data() {
    return {
      file: { name: 'Escolha uma imagem...' },
      model: { ...SETTINGS },
      resellers: [],
    };
  },
  watch: {},
  methods: {
    ...mapActions([
      'activeAlert',
    ]),
    choseFile() {
      [this.file] = this.$refs.file.files;
      this.model.logo = this.file.name;
    },
    onInput(search) {
      const params = {
        search,
        skip: 0,
        take: 10,
        page: 1,
      };
      ResellerService.getList(params)
        .then(response => {
          this.resellers = response.list;
        });
    },
    loadReseller(reseller) {
      if (this.$refs.resellerNational && reseller.national) {
        this.$refs.resellerNational.$refs.input.value = reseller.national.name;
      }
      if (this.$refs.resellerInternational && reseller.international) {
        this.$refs.resellerInternational.$refs.input.value = reseller.international.name;
      }
      if (this.$refs.resellerEngineering && reseller.engineering) {
        this.$refs.resellerEngineering.$refs.input.value = reseller.engineering.name;
      }
    },
    save() {
      const { reseller, ...payload } = this.model;
      SettingsService.saveOptions(payload, 'settings')
        .then(() => this.activeAlert({ message: 'Variáveis salvas com sucesso', theme: 'success' }))
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        })
        .finally(this.loading = false);
    },
    saveReseller(reseller, type = 'international') {
      const id = reseller.id.toString();

      const map = {
        national: 'resellerNational',
        international: 'resellerInternational',
        engineering: 'resellerEngineering',
      };

      this.model[map[type]] = id;
    },
    submit() {
      this.loading = true;
      const { settings } = this.$store.state.settings;
      if (this.file.name !== settings.logo) {
        return this.uploadLogoFile();
      }
      return this.save();
    },
    uploadLogoFile() {
      SettingsService.upload(this.file)
        .then(response => {
          this.model.logo = response.path;
          this.file.name = this.model.logo;
          this.save();
        });
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_SETTING_, newValue => {
      this.model = { ...newValue };
      this.loadReseller(newValue.reseller);
      this.file.name = this.model.logo;
    });
  },
};
</script>

<style lang="scss" scoped>
.custom-file-label {
  overflow: hidden;
  white-space: nowrap;
}
</style>
